import { Stack } from '@mantine/core';
import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { NoContentPlaceholder } from '@/core/components';

import { HierarchyDepartmentSelect } from '@feature/utils/components/HierarchyDepartmentSelect';
import { useDepartmentAdminHierarchy } from '@feature/utils/components/hooks/hierarchy/useHierarchy';

export function DepartmentAdminGovEvaluationHeader() {
  const { userId, selectProps } = useDepartmentAdminHierarchy();
  const { t } = useTranslation();

  return (
    <Stack>
      <HierarchyDepartmentSelect {...selectProps} />
      {userId == null && <NoContentPlaceholder title={t('hierarchySelectValidation.fromDepartments')} />}
      {userId != null && <Outlet />}
    </Stack>
  );
}
